import {
  Image,
  ImageBackground,
  Platform,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
} from "react-native";
import {
  ProfileChipPng,
  ProfileLevelProgressBarLightPng,
  ProfileLevelProgressBarFillPng,
  ProfileLevelProgressBarFramePng,
  ProfileSparklePng,
} from "../../../assets";
import React from "react";

import { AvatarFrameWithGradient } from "../index";
import {
  AvatarGradientColor,
  AvatarLevelPosition,
  AvatarSparklePosition,
} from "../../../../typings/types";
import { vars } from "../../../utils/helpers/vars";
import { useNavigation } from "@react-navigation/native";
import { NativeStackNavigationProp } from "@react-navigation/native-stack";
import { RootStackParamList } from "../../navigator";
import { useSelector } from "react-redux";
import { selectIsLogged } from "../../../store/auth/authReducer";
import { RootState } from "../../../store";
import { getAvatarUrl } from "../../../utils/axiosInstance";
type Nav = NativeStackNavigationProp<RootStackParamList>;

const Profile = () => {
  const { navigate } = useNavigation<Nav>();
  const isLogged = useSelector(selectIsLogged);
  const player = useSelector((s: RootState) => s.auth.user);

  const TOTAL_LEVELS = 20;
  const BAR_WIDTH = 111;
  const FIRST_WIDTH = 12;
  const CURRENT_LEVEL = player?.level ?? 1;

  let progressWidth;
  const isNative = Platform.OS !== "web";

  if (CURRENT_LEVEL <= 1) {
    progressWidth = FIRST_WIDTH;
  } else {
    const remainingLevels = TOTAL_LEVELS - 1;
    const remainingWidth = BAR_WIDTH - FIRST_WIDTH;
    const stepSize = remainingWidth / remainingLevels;
    progressWidth = FIRST_WIDTH + (CURRENT_LEVEL - 1) * stepSize;
  }
  return (
    <View style={{ flex: 1, maxHeight: 76 }}>
      <TouchableOpacity
        style={{
          maxWidth: isNative ? undefined : 150,
          // position: "absolute",
          // zIndex: 2,
        }}
        onPress={() => {
          if (isLogged) {
            navigate("Profile");
          } else {
            navigate("Login");
          }
        }}
      >
        {/*AVATAR*/}
        <AvatarFrameWithGradient
          gradientColor={
            player?.isVip ? AvatarGradientColor.Gold : AvatarGradientColor.Red
          }
          levelPosition={AvatarLevelPosition.TopRight}
          sparklePosition={AvatarSparklePosition.Left}
          showVipBadge={player?.isVip}
        />

        <Image
          source={ProfileSparklePng}
          style={{
            position: "absolute",
            top: 4,
            left: 34,
            width: 111,
            height: 60,
          }}
        />

        {/*USERNAME*/}
        <View
          style={{
            position: "absolute",
            top: 15,
            left: 94,
            maxWidth: 90,
          }}
        >
          <Text
            numberOfLines={1}
            ellipsizeMode="tail"
            style={{
              textAlign: "left",
              color: "white",
              fontSize: 12,
              fontWeight: "bold",
            }}
          >
            {player?.username ? player.username : "User"}
          </Text>
        </View>

        {/*PROGRESS BAR*/}
        <ImageBackground
          source={ProfileLevelProgressBarFramePng}
          style={{
            position: "absolute",
            width: 115,
            height: 14,
            top: 34,
            left: 70,
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <View
            style={{
              borderRadius: 50,
              width: 111,
              height: 11,
              overflow: "hidden",
            }}
          >
            <Image
              source={ProfileLevelProgressBarFillPng}
              style={{
                marginLeft: 11,
                borderTopRightRadius: 50,
                borderBottomRightRadius: 50,
                width: progressWidth,
                height: 11,
              }}
            />
          </View>

          <Image
            source={ProfileLevelProgressBarLightPng}
            style={{
              position: "absolute",
              width: 115,
              height: 11,
              top: 8,
            }}
          />
        </ImageBackground>

        <View
          style={{
            width: 115,
            height: 23,
            position: "absolute",
            top: 48,
            left: 70,
          }}
        >
          <View
            style={{
              width: "100%",
              height: "100%",
              borderTopRightRadius: 50,
              borderBottomRightRadius: 50,
              opacity: 0.5,
              backgroundColor: "#000",
              position: "absolute",
              display: "flex",
              flexDirection: "row",
            }}
          />

          <View
            style={{
              width: "100%",
              height: "100%",
              flexDirection: "row",
              justifyContent: "flex-start",
              alignItems: "center",
              marginLeft: 20,
              gap: 4,
            }}
          >
            <Image
              source={ProfileChipPng}
              style={{
                width: 16,
                height: 16,
              }}
            />

            <Text
              numberOfLines={1}
              ellipsizeMode="tail"
              style={{
                maxWidth: 60,
                color: "gold",
                fontSize: 12,
                fontWeight: "bold",
              }}
            >
              {player?.chips ? player?.chips : 1000}
            </Text>
          </View>
        </View>
      </TouchableOpacity>
    </View>
  );
};
export default Profile;

const styles = StyleSheet.create({
  avatar: {
    width: 48,
    height: 48,
    borderRadius: 24,
    marginRight: 8,
  },
  username: {
    color: "#fff",
    fontWeight: "bold",
  },
  progressBar: {
    flexDirection: "row",
    alignItems: "center",
  },
  level: {
    position: "absolute",
    maxWidth: 20,
    textAlign: "center",
    top: 16,
    left: 44,
    color: "#fff",
    fontSize: 14,
    fontWeight: "bold",
  },
  chips: {
    top: 3,
    left: 45,
    maxWidth: 65,
    color: "gold",
    fontSize: 12,
  },
});
